import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  colors,
  Divider,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import "./NlpCard.css";
import logo from "../../../../../images/indian-bank/Group 14894 (1).svg";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";

export default function NlpCardHerocard(props) {
  // const [isShowAdditionalData, setIsShowAdditionalData] = React.useState(false);
  // const [url, setUrl] = React.useState("");

  // const [isValuePresent, setIsValuePresent] = React.useState(true);
  // const [showValue, setShowValue] = React.useState(true);

  let main_title;
  let main_value;
  let main_link;
  // let additional_data_url;

  //First content
  // let result = props.adyanlpdata.result;
  let resultData = props.adyanlpdata.result[0];
  // let additional_data_url = props.adyanlpdata.result[0].additional_data.url;
  main_title = resultData.main_title;
  main_value = resultData.value;
  main_link = resultData.url;

  return (
    <div className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70"style={{ border: "8px solid rgba(244, 176, 53, 0.8)" ,backgroundColor:"rgba(245, 243, 243, 1) !important"
    }}>
      <Grid item xs>
        <Typography
          gutterBottom
          variant="button"
          align="center"
          display="block"
          style={{ color: "rgba(12, 77, 162, 1)", fontSize: "18px" ,textAlign:"center",fontWeight:"600"}}
        >
          {main_title}
        </Typography>
      </Grid>
      <Grid item xs>
        <Card>
          {/* Indian Bank Logo */}
          <CardActionArea>
            <CardMedia component="img" image={logo} alt="ib" style={{backgroundColor:"rgba(245, 243, 243, 1)"}}/>
          </CardActionArea>
          {/* <CardContent>
            <TextField
              id="outlined-multiline-static"
              multiline
              variant="outlined"
              value={main_value}
            />
          </CardContent> */}
          {/* TEST */}
          {main_value != "" ? (
            <CardContent>
              <TextField
                id="outlined-multiline-static"
                multiline
                variant="outlined"
                value={main_value}
              />
            </CardContent>
          ) : (
            <CardContent>
              <TextField
                id="outlined-multiline-static"
                multiline
                variant="outlined"
                value="Click The Button Below for Info"
              />
            </CardContent>
          )}
          {/* {additional_data_url != "" ? (
            <CardActions>
              <Button
                size="small"
                color="primary"
                href={additional_data_url}
                // href={url}
                startIcon={<PictureAsPdfIcon />}
                target="_blank"
              >
                Click for Additional Info
              </Button>
            </CardActions>
          ) : (
            <></>
          )} */}
        </Card>
      </Grid>
      <Grid item className="grid-btn">
        <Typography
          variant="caption"
          display="block"
          gutterBottom
          className="typography_link_center"
        >
          <Button
            variant="contained"
            size="small"
            href={main_link}
            target="_blank"
            
          >
            Click For More
          </Button>
        </Typography>
      </Grid>
      {/* </div> */}
    </div>
  );
}
